import { cn } from 'src/lib/utils';
import type { TaskRunStatus } from '../types/scheduler.types';

const STATUS_STYLES: Record<TaskRunStatus, string> = {
  pending: 'bg-amber-100 text-amber-800',
  running: 'bg-blue-100 text-blue-800',
  success: 'bg-[rgba(49,187,100,0.15)] text-[#31BB64]',
  failed: 'bg-red-101 text-red-700',
  skipped: 'bg-gray-300 text-gray-700',
};

interface SchedulerStatusBadgeProps {
  status: TaskRunStatus | string | null | undefined;
  className?: string;
}

export function SchedulerStatusBadge({ status, className }: SchedulerStatusBadgeProps) {
  const key = (status ?? 'skipped') as TaskRunStatus;
  const styleClass = STATUS_STYLES[key] ?? STATUS_STYLES.skipped;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize',
        styleClass,
        className
      )}
    >
      {key}
    </span>
  );
}
